module.exports = __webpack_public_path__ + "img/50.b7c69d17.png";